import { render, staticRenderFns } from "./LogoFooter.vue?vue&type=template&id=c1d144b8"
import script from "./LogoFooter.vue?vue&type=script&lang=js"
export * from "./LogoFooter.vue?vue&type=script&lang=js"
import style0 from "./LogoFooter.vue?vue&type=style&index=0&id=c1d144b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports